<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1300"
    scrollable
    :fullscreen="fullscreen"
  >
    <the-score-card @close-dialog="close"></the-score-card>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import { ACTIONS } from "@/store";

import TheScoreCard from "./TheScoreCard";

export default {
  name: "TheScoreDialog",
  components: { TheScoreCard },
  data: () => ({}),
  props: {
    dialog: { type: Boolean, required: true },
  },
  computed: {
    fullscreen() {
      return false;
    },
  },
  methods: {
    ...mapActions({
      load: ACTIONS.LOAD_COMPARED_CARDS_DATA,
    }),
    close() {
      this.$emit("input", false);
    },
  },
  watch: {
    dialog: "load",
  },
};
</script>
